import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["tooltip"]

  copy(event) {
    const value = event.params.value
    const target = this.tooltipTarget

    navigator.clipboard.writeText(value).then(() => {
      target.classList.add("tooltip")
      target.classList.add("tooltip-open")

      setTimeout(() => {
        target.classList.remove("tooltip")
        target.classList.remove("tooltip-open")
      }, 1000)
    })
  }
}
